import { PhoneNumberFormat as PNF, PhoneNumberUtil } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

export const formatPhone = (phone: string): string => {
  try {
    return phoneUtil.format(phoneUtil.parse(phone), PNF.INTERNATIONAL);
  } catch (e) {
    return phone;
  }
};
